import {Preloader} from "components/Preloader";
import {RequestState} from "modules";
import {showGageError} from "modules/actions";
import {checkGeo, getCountry} from "modules/actions/user";
import {geoRequestStateSelector, isCountryAllowedSelector} from "modules/selectors/user";
import {redirectToMlbIneligible} from "modules/utils/mlbConfig";
import React, {Fragment, useEffect, PropsWithChildren} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import styled from "@emotion/styled";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	height: 400px;
	font-size: 16px;
`;

export const HOCCountryCheck: React.FC<PropsWithChildren> = ({children}) => {
	const dispatch = useDispatch();
	const isCountryAllowed = useSelector(isCountryAllowedSelector);
	const requestState = useSelector(geoRequestStateSelector);
	const i18n = useTranslation();

	useEffect(() => {
		dispatch(checkGeo());
		dispatch(getCountry());
	}, [dispatch]);

	const isRedirect = requestState === RequestState.Received && !isCountryAllowed;

	useEffect(() => {
		let timeout: NodeJS.Timeout;

		if (isRedirect) {
			timeout = setTimeout(redirectToMlbIneligible, 5000);
		}

		return () => {
			if (isRedirect) {
				clearTimeout(timeout);
			}
		};
	}, [isRedirect]);

	useEffect(() => {
		if (requestState === RequestState.Received && !isCountryAllowed) {
			dispatch(showGageError(i18n.t("messages.game.country_locked")));
		}
	}, [i18n, dispatch, isCountryAllowed, requestState]);

	return requestState === RequestState.Received ? (
		<Fragment>
			{isCountryAllowed ? (
				<Fragment>{children}</Fragment>
			) : (
				<Wrapper>{i18n.t("messages.game.country_locked_redirect")}</Wrapper>
			)}
		</Fragment>
	) : (
		<Preloader />
	);
};
